import clsx from "clsx";

import { formatPrice, getPictureById } from "~/utils";

import styles from "./index.module.scss";

/** Подарок к заказу (колпачок): отдельный блок без кнопок количества и удаления. */
export default function CartGift({ items, className }) {
  if (!items?.length) return null;

  return (
    <div className={clsx(styles.Gifts, className)}>
      {items.map((item) => (
        <div className={styles.Gift} key={item.ID} data-test="cartGift">
          <div className={styles.Photo}>
            <img
              src={getPictureById(item.PRODUCT_DATA?.PICTURE_ID)?.small}
              alt={item.PRODUCT_DATA?.NAME || item.NAME}
            />
          </div>
          <div className={styles.Info}>
            <div className={styles.Label}>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"
                  stroke="#1E7A14"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Подарок к заказу
            </div>
            <div className={styles.Name}>
              {item.PRODUCT_DATA?.NAME || item.NAME}
            </div>
          </div>
          <div className={styles.Price}>
            <div className={styles.PriceOld}>
              {formatPrice(item.NO_DISCOUNT_PRICE_TOTAL)} руб
            </div>
            <div>Бесплатно</div>
          </div>
        </div>
      ))}
    </div>
  );
}
